(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-jewelry-collection-template"]) return;
  try {
    
  jQuery(function($){
    let trigger = $('#filters_trigger');
    trigger.click(function(){
      $('.collection-filters').fadeToggle();
    })

      let parent = $('.collection-nav .has-dropdown');
      let sub = parent.find('.dropdown');
      let subActive = sub.find('.active');

      if(subActive.length > 0){
        subActive.closest('.has-dropdown').addClass('expanded');
        subActive.closest('.dropdown').show();
      }

      $('.best-sellers-slider').slick({
        dots: false,
        arrows: true,
        prevArrow: '<div class="slick-prev slider-prev slider-arrow"><svg class="icon"><use xlink:href="#left-angle" /></svg></div>',
        nextArrow: '<div class="slick-next slider-next slider-arrow"><svg class="icon"><use xlink:href="#right-angle" /></svg></div>',
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-positions"]) return;
  try {
    
  jQuery(document).ready(function($){
    function runFAQ(){
      var toggleBlocks = $('.toggle-block');
      console.log(toggleBlocks);

      if(toggleBlocks){
        toggleBlocks.each(function(){
          $(this).find('.toggle-trigger').click(function(){
            if($(this).closest('.toggle-block').hasClass('toggled')){
              $(this).parents('.available-positions-wrapper').find('.toggle-block.toggled').find('.toggle-item').fadeToggle('fast');
              $(this).parents('.available-positions-wrapper').find('.toggle-block').removeClass('toggled');
            } else {
              $(this).parents('.available-positions-wrapper').find('.toggle-block.toggled').find('.toggle-item').fadeToggle('fast');
              $(this).parents('.available-positions-wrapper').find('.toggle-block').removeClass('toggled');

              if($(this).parent().hasClass('toggled')){
                $(this).parent().removeClass('toggled')
              } else {
                $(this).parent().addClass('toggled')
              }
              $(this).next('.toggle-item').fadeToggle('fast');
            }
          })
        });
      }
    }

    runFAQ();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  jQuery(function($){
    let trigger = $('#filters_trigger');

    trigger.click(function(){
      $('.collection-filters').fadeToggle();
    });

    let parent = $('.collection-nav .has-dropdown');
    let sub = parent.find('.dropdown');
    let subActive = sub.find('.active');

    if(subActive.length > 0){
      subActive.closest('.has-dropdown').addClass('expanded');
      subActive.closest('.dropdown').show();
    }

    $('.best-sellers-slider').slick({
      dots: false,
      arrows: true,
      prevArrow: '<div class="slick-prev slider-prev slider-arrow"><svg class="icon"><use xlink:href="#left-angle" /></svg></div>',
      nextArrow: '<div class="slick-next slider-next slider-arrow"><svg class="icon"><use xlink:href="#right-angle" /></svg></div>',
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

    $('.collection-seo-content').each(function(){
      const seoSection = $(this);
      const seoText = seoSection.find('.collection-seo-content__text');
      const seoToggle = seoSection.find('.collection-seo-content__toggle');

      seoToggle.on('click', function(){
        const isExpanded = seoText.hasClass('is-expanded');

        seoText.toggleClass('is-expanded', !isExpanded);
        seoToggle.attr('aria-expanded', !isExpanded);
        seoToggle.text(!isExpanded ? 'View Less' : 'View More');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare"] && !Shopify.designMode) return;
  try {
    
  var dragging = false,
        scrolling = false,
        resizing = false;
    //cache jQuery objects
    var imageComparisonContainers = $('.cd-image-container');
    //check if the .cd-image-container is in the viewport 
    //if yes, animate it
    checkPosition(imageComparisonContainers);
    $(window).on('scroll', function(){
        if( !scrolling) {
            scrolling =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkPosition(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkPosition(imageComparisonContainers);});
        }
    });

    //make the .cd-handle element draggable and modify .cd-resize-img width according to its position
    imageComparisonContainers.each(function(){
        var actual = $(this);
        drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual, actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-image-label[data-type="modified"]'));
    });

    //upadate images label visibility
    $(window).on('resize', function(){
        if( !resizing) {
            resizing =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkLabel(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkLabel(imageComparisonContainers);});
        }
    });

    function checkPosition(container) {
        container.each(function(){
            var actualContainer = $(this);
            if( $(window).scrollTop() + $(window).height()*0.5 > actualContainer.offset().top) {
                actualContainer.addClass('is-visible');
            }
        });

        scrolling = false;
    }

    function checkLabel(container) {
        container.each(function(){
            var actual = $(this);
            updateLabel(actual.find('.cd-image-label[data-type="modified"]'), actual.find('.cd-resize-img'), 'left');
            updateLabel(actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-resize-img'), 'right');
        });

        resizing = false;
    }

    //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
    function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
        dragElement.on("mousedown vmousedown", function(e) {
            dragElement.addClass('draggable');
            resizeElement.addClass('resizable');

            var dragWidth = dragElement.outerWidth(),
                xPosition = dragElement.offset().left + dragWidth - e.pageX,
                containerOffset = container.offset().left,
                containerWidth = container.outerWidth(),
                minLeft = containerOffset + 10,
                maxLeft = containerOffset + containerWidth - dragWidth - 10;
            
            dragElement.parents().on("mousemove vmousemove", function(e) {
                if( !dragging) {
                    dragging =  true;
                    ( !window.requestAnimationFrame )
                        ? setTimeout(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);}, 100)
                        : requestAnimationFrame(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);});
                }
            }).on("mouseup vmouseup", function(e){
                dragElement.removeClass('draggable');
                resizeElement.removeClass('resizable');
            });
            e.preventDefault();
        }).on("mouseup vmouseup", function(e) {
            dragElement.removeClass('draggable');
            resizeElement.removeClass('resizable');
        });
    }

    function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
        var leftValue = e.pageX + xPosition - dragWidth;   
        //constrain the draggable element to move inside his container
        if(leftValue < minLeft ) {
            leftValue = minLeft;
        } else if ( leftValue > maxLeft) {
            leftValue = maxLeft;
        }

        var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
        
        $('.cd-handle.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
            $(this).removeClass('draggable');
            resizeElement.removeClass('resizable');
        });

        $('.resizable').css('width', widthValue); 

        updateLabel(labelResizeElement, resizeElement, 'left');
        updateLabel(labelContainer, resizeElement, 'right');
        dragging =  false;
    }

    function updateLabel(label, resizeElement, position) {
        if(position == 'left') {
            ( label.offset().left + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        } else {
            ( label.offset().left > resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-video"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function($){
    function sizeVid(){
      var v = $('#video');
      var vc = v.closest('.video-container');
      var vcw = vc.width();
      v.width(vcw);
      v.height(vcw * 0.56);
    }

    sizeVid();

    $(window).resize(function(){
      console.log('test');
      sizeVid();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() { super(); }
    hide() { super.hide(); }
    show(opener) { super.show(opener); this.showActiveMedia(); }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promos"]) return;
  try {
    
  jQuery(document).ready(function($){
    var popup = $('.popup-modal');
    var delay = popup.data('delay');
    var showAgain = popup.data('show-again');
    var hidePopup = $.cookie('hide_subscribe');

    function show_subscribe(){
      if(hidePopup != 'true') {
        popup.fadeIn();
      }
    }

    setTimeout(show_subscribe, delay);
  
    $('#popup-close').click(function(e){
      e.preventDefault();
      popup.fadeOut();
    });

    $.cookie('hide_subscribe', 'true', { expires: showAgain, path: '/' });

    var InfiniteRotator =
    {
        init: function()
        {
            //initial fade-in time (in milliseconds)
            var initialFadeIn = 0;
 
            //interval between items (in milliseconds)
            var itemInterval = ($('.rotate-bar').data('rotate-speed')*1000);
 
            //cross-fade time (in milliseconds)
            var fadeTime = 500;
 
            //count number of items
            var numberOfItems = $('.rotate-bar').length;
 
            //set current item
            var currentItem = 0;
 
            //show first item
            $('.rotate-bar').eq(currentItem).toggleClass('rotate-show').find('.promo-bar-text').fadeIn(initialFadeIn);

            function rotateItems(){
              $('.rotate-bar').eq(currentItem).toggleClass('rotate-show').find('.promo-bar-text').fadeOut(fadeTime);
 
              if(currentItem == numberOfItems -1){
                  currentItem = 0;
              }else{
                  currentItem++;
              }

              $('.rotate-bar').eq(currentItem).toggleClass('rotate-show').find('.promo-bar-text').fadeIn(fadeTime);
            }
 
            //loop through the items
            var infiniteLoop = setInterval(function(){
              rotateItems();
            }, itemInterval);
        }
    };
 
    InfiniteRotator.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["references"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($){
  $('.references-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.references-nav'
  });
  $('.references-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.references-for',
    arrows: false,
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-look-index-bottom"]) return;
  try {
    
  jQuery(function($){
    $('.shop-look-index-block-items-bottom').slick({
      dots: false,
      arrows: true,
      prevArrow: '<div class="slick-prev slider-prev slider-arrow"><svg class="icon"><use xlink:href="#left-angle" /></svg></div>',
      nextArrow: '<div class="slick-next slider-next slider-arrow"><svg class="icon"><use xlink:href="#right-angle" /></svg></div>',
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
              }
          },
          {
              breakpoint: 600,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
              }
          }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-look-index-more"]) return;
  try {
    
jQuery(document).ready(function($){
  function runSlider(){
    $('.shop-look-more').slick({
			dots: false,
			arrows: true,
			prevArrow: '<div class="slick-prev slider-prev slider-arrow"><svg class="icon"><use xlink:href="#left-angle" /></svg></div>',
			nextArrow: '<div class="slick-next slider-next slider-arrow"><svg class="icon"><use xlink:href="#right-angle" /></svg></div>',
      infinite: true,
			slidesToShow: 3,
			slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  runSlider();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-look-index-top"]) return;
  try {
    
  jQuery(function($){
    $('.shop-look-index-block-items-top').slick({
      dots: false,
      arrows: true,
      prevArrow: '<div class="slick-prev slider-prev slider-arrow"><svg class="icon"><use xlink:href="#left-angle" /></svg></div>',
      nextArrow: '<div class="slick-next slider-next slider-arrow"><svg class="icon"><use xlink:href="#right-angle" /></svg></div>',
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
              }
          },
          {
              breakpoint: 600,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
              }
          }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smash-faq"] && !Shopify.designMode) return;
  try {
    
  function runFAQ(){
		var toggleBlocks = $('.toggle-block');

		if(toggleBlocks){
			toggleBlocks.each(function(){
				$(this).find('.toggle-trigger').click(function(){
					if($(this).closest('.toggle-block').hasClass('toggled')){
						$(this).parents('.page-faq-wrapper').find('.toggle-block.toggled').find('.toggle-item').fadeToggle('fast');
						$(this).parents('.page-faq-wrapper').find('.toggle-block').removeClass('toggled');
					} else {
						$(this).parents('.page-faq-wrapper').find('.toggle-block.toggled').find('.toggle-item').fadeToggle('fast');
						$(this).parents('.page-faq-wrapper').find('.toggle-block').removeClass('toggled');

						if($(this).parent().hasClass('toggled')){
							$(this).parent().removeClass('toggled')
						} else {
							$(this).parent().addClass('toggled')
						}
						$(this).next('.toggle-item').fadeToggle('fast');
					}
				})
			});
		}
	}
	runFAQ();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smash-slideshow"] && !Shopify.designMode) return;
  try {
    

jQuery(document).ready(function($){

  function runSlider(){

    let slider = $('.smash-slideshow');

    slider.each(function(){

      let _ = $(this);

      let ap = _.data('autoplay');
      let apS = _.data('autoplaySpeed');
      let dts = _.data('dots');
      let arws = _.data('arrows');

      _.slick({
        dots: dts,
        arrows: arws,

        prevArrow: "#custom-prev-arrow",
        nextArrow: "#custom-next-arrow",

        infinite: true,
        adaptiveHeight: false,

        autoplay: ap,
        autoplaySpeed: apS,

        slidesToShow: 1,
        slidesToScroll: 1
      });

    });

  }


  function sizeSlides() {

    var slides = $('.smash-slideshow').find('.slick-slide');

    var h = 0;

    slides.each(function(){

      var ch = $(this).height();

      if(ch > h){
        h = ch;
      }

    });


    slides.each(function(){
      $(this).height(h);
    });

  }


  runSlider();

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-careers"]) return;
  try {
    
  jQuery(document).ready(function($){
    function sizeVid(){
      var v = $('#video');
      var vc = v.closest('.video-wrapper');
      var vcw = vc.width();
      v.width(vcw);
      v.height(vcw * 0.56);
    }

    sizeVid();

    $(window).resize(function(){
      console.log('test');
      sizeVid();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
